import React, { useState, useEffect } from 'react';
import styles from '../style/components/Navbar.module.css';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Close mobile menu when clicking a link
  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`${styles.header} ${scrolled ? styles.scrolled : ''}`}>
      <div className={styles.navContainer}>
        {/* Logo */}
        <div className={styles.navlogo}>
          <a href="/">
            <img src="/Images/logo.png" alt="Company Logo" />
          </a>
        </div>

        {/* Desktop Navigation */}
        <nav className={styles.navbar}>
          <ul>
            <li><a href="/" className={styles.navLink}>Home</a></li>
            <li className={styles.dropdown}>
              <a href="/Forms" className={styles.navLink}>
                Forms <span className={styles.dropdownIcon}>▼</span>
              </a>
              <div className={styles.dropdownContent}>
                <a href="/SeniorCollege">Senior College</a>
                <a href="/PriSecHSchool">Primary, Secondary and Higher Secondary School </a>
                <a href="/Arrears">Arrears</a>
                <a href="/pension">Pension</a>
                {/* Add more forms as needed */}
              </div>
            </li>
            <li><a href="/GR" className={styles.navLink}>GR</a></li>
            <li><a href="/pricing-plans" className={styles.navLink}>Pricing</a></li>
            <li><a href="/AboutPage" className={styles.navLink}>About</a></li>
            <li><a href="/ContactPage" className={styles.navLink}>Contact</a></li>
          </ul>
        </nav>

        {/* Call-to-Action Button */}
        <div className={styles.ctaContainer}>
          <a 
            href="https://www.youtube.com/@himanshusalarycorner6244" 
            className={styles.ctaButton}
            target="_blank"
            rel="noopener noreferrer"
          >
            Watch us on YouTube
          </a>
        </div>


        {/* Mobile Menu Button */}
        <button
          className={`${styles.navbarToggle} ${isMobileMenuOpen ? styles.open : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle Menu"
          aria-expanded={isMobileMenuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {/* Mobile Navigation */}
      <div className={`${styles.navbarMobile} ${isMobileMenuOpen ? styles.active : ''}`}>
        <ul>
          <li><a href="/" className={styles.navLinkMobile} onClick={closeMobileMenu}>Home</a></li>
          <li className={styles.dropdownMobile}>
              <a href="/Forms" className={styles.navLinkMobile}>
                Forms <span className={styles.dropdownIconMobile}>▼</span>
              </a>
              <div className={styles.dropdownContentMobile}>
                <a href="/SeniorCollege">Senior College</a>
                <a href="/PriSecHSchool">Primary, Secondary and Higher Secondary School </a>
                <a href="/Arrears">Arrears</a>
                <a href="/pension">Pension</a>
                {/* Add more forms as needed */}
              </div>
            </li>

          <li><a href="/GR" className={styles.navLinkMobile} onClick={closeMobileMenu}>GR</a></li>
          <li><a href="/pricing-plans" className={styles.navLinkMobile} onClick={closeMobileMenu}>Pricing</a></li>
          <li><a href="/AboutPage" className={styles.navLinkMobile} onClick={closeMobileMenu}>About</a></li>
          <li><a href="/ContactPage" className={styles.navLinkMobile} onClick={closeMobileMenu}>Contact</a></li>
          <li>
            <a href="/get-started" className={styles.ctaButtonMobile} onClick={closeMobileMenu}>
              Get Started
            </a>
          </li>
        </ul>
      </div>
    </header>
  );
};

export default Navbar;